import { toast } from 'react-toastify';
import RecepcaoContratosTypes from './types';
import 'react-toastify/dist/ReactToastify.css';

import { MESSAGES } from '../../../../constants/messages';

const INITIAL_STATE = {
  contrato: '',
  numero_protocolo: '',
  cpf: '',
  contratos_recepcionados: [],
  id: undefined,
  redirectFinalizacao: false,
  nome: '',
  dataContrato: '',
  produto: '',
  recepcionado: false,
  idContrato: '',
};

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case RecepcaoContratosTypes.CLEAR:
      return {
        ...state,
        contratos: [],
        numero_protocolo: 0,
        nome: '',
        dataContrato: '',
        produto: '',
        recepcionado: '',
        _iddossie: '',
        cpf: '',
        contratos_recepcionados: [],
        id: undefined,
        redirectFinalizacao: false,
      };

    case RecepcaoContratosTypes.SEARCH_REQUEST:
      return {
        ...state,
        numero_protocolo: action.protocolo,
        loading: true,
      };

    case RecepcaoContratosTypes.SEARCH_SUCCESS:
      const contratos = [];
      const nome = '';
      const dataContrato = '';
      const produto = '';
      const recepcionado = '';
      const _iddossie = '';
      const cpf = '';
      if (action.payload.length > 0) {
        contratos.push({
          contrato: action.payload[0].NumeroContrato,
          nome: action.payload[0].Nome,
          dataContrato: action.payload[0].DataContrato,
          produto: action.payload[0].Produto,
          recepcionado: action.payload[0].Recepcionado,
          _iddossie: action.payload[0].IdContrato,
          cpf: action.payload[0].CPFCNPJ,
          numero_etiqueta: action.payload[0].CodigoEtiqueta,
        });
      }

      return {
        ...state,
        contratos,
        loading: false,
        error: false,
      };

    case RecepcaoContratosTypes.RECEPCIONAR_REQUEST:
      return { ...state, loading: true };

    case RecepcaoContratosTypes.RECEPCIONAR_SUCCESS:
      return {
        ...state,
        redirectFinalizacao: true,
        loading: false,
        error: false,
      };

    case RecepcaoContratosTypes.REQUEST_FAILURE:

      const mensagem = action.payload ? action.payload : MESSAGES.DEFAULT_ERROR_MESSAGE;
      toast.error(mensagem);

      return { ...state, loading: false, error: true };

    case RecepcaoContratosTypes.SEARCH_USUARIOS_REQUEST:
      return {
        ...state,
      };

    case RecepcaoContratosTypes.SEARCH_USUARIOS_SUCCESS:
      const user = action.payload.map((item) => ({ value: item, label: (`${item.codigo} - ${item.nome}`) }));
      return {
        ...state,
        usuarios: user,
      };

    default:
      return state;
  }
};
